"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/** @optimized using svgo:^3.0.2 */
export const WomanOwned = createSVGIcon(
  <path
    stroke="currentColor"
    d="M33.28 37.34h-7.53v-10.1a11.91 11.91 0 1 0-1.5 0v10.1h-7.53a.75.75 0 1 0 0 1.5h7.53v6.83a.75.75 0 0 0 1.5 0v-6.83h7.53a.75.75 0 0 0 0-1.5zM14.59 15.43A10.41 10.41 0 1 1 25 25.78a10.39 10.39 0 0 1-10.41-10.35z"
  />,
  "WomanOwned",
  { viewBox: "0 0 50 50", titleAccess: "WomanOwned", fill: "none" }
);
